// extracted by mini-css-extract-plugin
export default {"menu":"MapMenu_menu__irlFl","closed":"MapMenu_closed__69xF0","body":"MapMenu_body__QH6YP","info":"MapMenu_info__Hxor5","closeBtn":"MapMenu_closeBtn__pj0Vu"};